<div *ngIf="showNavigation">
  <nav id="navbar" [class.sticky]="isSticky" [class.absolute]="!isSticky">
    <div class="container">
      <div class="logo">
        <a class="navbar-brand" href="/home" (click)="onMenuItemClick()">
          <img [src]="imageUrl" alt="Logo">
        </a>
      </div>
      
      <div class="menu-icon" [style.color]="warna" (click)="toggleMenu()">
        <i class="fas fa-bars"></i>
      </div>

      <ul class="nav-links" [ngClass]="{'active': menuActive}">
        <li class="nav-item" *ngFor="let item of menuItems" [ngClass]="{'has-submenu': item.subItems.length > 0}">
          
          <!-- Menu items without submenu -->
          <ng-container *ngIf="!item.subItems.length">
            <a [routerLink]="item.route"
               (click)="onMenuItemClick()"
               [ngClass]="[isSticky ? 'nav-link wr2' : 'nav-link wr1', isMenuActive2(item.route) ? 'active' : '']">
              <i *ngIf="item.icon" [class]="item.icon" style="font-size: 1.2rem; position: relative;">
                <!-- Badge -->
                <span *ngIf="showBadge" 
                      class="badge" 
                      style="position: absolute; top: -5px; right: -10px; background-color: red; color: white; border-radius: 50%; padding: 2px 6px; font-size: 0.7rem;">
                  !
                </span>
              </i>
              <span *ngIf="item.name">{{ item.name }}</span>
            </a>
          </ng-container>

          <!-- Menu items with submenu -->
          <ng-container *ngIf="item.subItems.length">
            
            <!-- User icon style submenu -->
            <ng-container *ngIf="item.icon=='fas fa-user-circle'; else other_content">
              <a [ngClass]="[isSticky ? 'nav-link wr2' : 'nav-link wr1', isMenuActive(item) ? 'active' : '']"
                 (click)="toggleSubmenu($event, item)"
                 class="has-submenu">
                <i *ngIf="item.icon" [class]="item.icon" style=" font-size: 1.2rem;"></i>         
                <span *ngIf="item.name">{{ item.name }}</span>
              </a>

              <ul class="submenu2" [class.show]="item.isSubmenuOpen">
                <li class="submenu-item" *ngFor="let subItem of item.subItems">
                  <a class="submenu-link"
                     [routerLink]="subItem.route"
                     [routerLinkActive]="'active'"
                     [class.active]="isSubmenuActive(subItem)"
                     (click)="handleSubmenuClick($event, subItem)">
                    <i *ngIf="subItem.icon" [class]="subItem.icon + ' me-2'"></i>
                    {{ subItem.name }}
                  </a>
                </li>
              </ul>
            </ng-container>

            <!-- Normal submenu -->
            <ng-template #other_content>
              <a [ngClass]="[isSticky ? 'nav-link wr2' : 'nav-link wr1', isMenuActive(item) ? 'active' : '']"
                 (click)="toggleSubmenu($event, item)"
                 class="has-submenu">
                <i *ngIf="item.icon" [class]="item.icon" style=" font-size: 1.5rem;"></i>
                <span *ngIf="item.name">{{ item.name }}</span>
                <i class="fas fa-chevron-down ms-1"></i>
              </a>
              <ul class="submenu" [class.show]="item.isSubmenuOpen">
                <li class="submenu-item" *ngFor="let subItem of item.subItems">
                  <a class="submenu-link"
                     [routerLink]="subItem.route"
                     [routerLinkActive]="'active'"
                     [class.active]="isSubmenuActive(subItem)"
                     (click)="handleSubmenuClick($event, subItem)">
                    <i *ngIf="subItem.icon" [class]="subItem.icon + ' me-2'"></i>
                    {{ subItem.name }}
                  </a>
                </li>
              </ul>
            </ng-template>
          </ng-container>
        </li>
      </ul>
    </div>
  </nav>

  <!-- Tombol WhatsApp -->
  <a [href]="whatsappUrl" 
     class="whatsapp-btn" 
     target="_blank" 
     data-bs-toggle="tooltip" 
     title="Chat via WhatsApp" 
     (click)="onMenuItemClick()">
    <i class="fab fa-whatsapp"></i>
  </a>
</div>
